import { render, staticRenderFns } from "./StockItemsTable.vue?vue&type=template&id=7bdeeb4c&"
import script from "./StockItemsTable.vue?vue&type=script&lang=js&"
export * from "./StockItemsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports